'use client'

import { createContext, PropsWithChildren, ReactNode, useContext, useState } from 'react'

type Context = {
  component?: ReactNode
  setComponent: (component: ReactNode | undefined) => void
  setTitle: (title: string) => void
  title?: string
}

const SiteHeaderContext = createContext<Context | null>(null)

export const SiteHeaderProvider = ({ children }: PropsWithChildren) => {
  const [title, setTitle] = useState<string>()
  const [component, setComponent] = useState<ReactNode>()

  return (
    <SiteHeaderContext.Provider value={{ component, setComponent, setTitle, title }} data-sentry-element="SiteHeaderContext.Provider" data-sentry-component="SiteHeaderProvider" data-sentry-source-file="context.tsx">
      {children}
    </SiteHeaderContext.Provider>
  )
}

export const useSiteHeader = () => {
  const context = useContext(SiteHeaderContext)

  if (!context) {
    throw new Error('useSiteHeader must be used within a SiteHeaderProvider')
  }

  return context
}
